import * as React from 'react';
import { SpeedDial } from '@syncfusion/ej2-buttons';
import { ComponentBase, applyMixins } from '@syncfusion/ej2-react-base';
/**
 * `SpeedDialComponent` represents the react SpeedDial Component.
 * ```ts
 * <SpeedDialComponent content='Edit'></SpeedDialComponent>
 * ```
 */
export class SpeedDialComponent extends SpeedDial {
    constructor(props) {
        super(props);
        this.initRenderCalled = false;
        this.checkInjectedModules = false;
        this.directivekeys = { 'speedDialItems': 'speedDialItem' };
        this.statelessTemplateProps = null;
        this.templateProps = null;
        this.immediateRender = false;
        this.isReactMock = true;
        this.portals = [];
    }
    render() {
        this.isReactMock = false;
        if (((this.element && !this.initRenderCalled) || this.refreshing) && !this.isReactForeceUpdate) {
            super.render();
            this.initRenderCalled = true;
        }
        else {
            return React.createElement('button', this.getDefaultAttributes(), [].concat(this.props.children, this.portals));
        }
    }
}
applyMixins(SpeedDialComponent, [ComponentBase, React.Component]);
